// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"307ce7ac","247":"7dfb355f","919":"fbdf07c4","996":"3d74de61"}[chunkId] + ".chunk.js";
};